import api from './api'

export interface QuickBooksStatus {
  connected: boolean
  realmId: string | null
  tokenExpiresAt: string | null
}

export const quickbooksService = {
  async getStatus(): Promise<QuickBooksStatus> {
    const { data } = await api.get('/quickbooks/status')
    return data
  },

  /**
   * Fetches the Intuit OAuth authorization URL from the backend (authenticated),
   * then returns it so the caller can redirect the browser to it.
   */
  async getConnectUrl(): Promise<string> {
    const { data } = await api.get('/quickbooks/auth-url')
    return data.url
  },

  async disconnect(): Promise<void> {
    await api.delete('/quickbooks/disconnect')
  },
}
